import { ReactNode } from "react";

interface ContainerProps {
  className?: string;
  children: ReactNode | ReactNode[];
}

const Container = ({ className, children }: ContainerProps) => (
  <div className={className ? `o-container ${className}` : "o-container"}>{children}</div>
);

export default Container;
